import {
  calculateVolumeAndUnits,
  canUseFractionedQuantity,
  convertVolumeAndUnitsToQuantity,
  formatQuantityToVolumeAndUnits,
} from '../../../../../services/util/volume-and-units.service'

function normalizeLabel(value) {
  return typeof value === 'string' ? value.trim() : ''
}

function formatVolumeInputValue(volume, units) {
  if (volume === 0 && units < 0) return '-0'
  return String(volume)
}

export function getSobraQuantityConfig(item = {}) {
  const unitSku = Number(item.unit_sku || 0)
  const caixaComPesoVariavel =
    item.caixa_com_peso_variavel === true || Number(item.caixa_com_peso_variavel) === 1

  return {
    unitSku,
    caixaComPesoVariavel,
    unAgregadora: item.un_agregadora || null,
    unFracionada: item.un_fracionada || null,
    canUseFractionedInput: canUseFractionedQuantity(unitSku, caixaComPesoVariavel),
  }
}

export function getSobraInputLabels(item) {
  const { unAgregadora, unFracionada } = getSobraQuantityConfig(item)

  return {
    volumeLabel: normalizeLabel(unAgregadora) || 'Vol.',
    unitsLabel: normalizeLabel(unFracionada) || 'Frac.',
  }
}

export function buildSobraQuantityInputState(item, quantity) {
  const { unitSku, caixaComPesoVariavel } = getSobraQuantityConfig(item)

  if (quantity === '' || quantity === null || quantity === undefined) {
    return {
      quantityValue: '',
      volumeValue: '',
      unitsValue: '',
    }
  }

  const { volume, units } = calculateVolumeAndUnits(quantity, unitSku, caixaComPesoVariavel)

  return {
    quantityValue: Number(quantity),
    volumeValue: formatVolumeInputValue(volume, units),
    unitsValue: String(units),
  }
}

export function getSobraQuantityValueFromInputs(item, volumeValue, unitsValue) {
  const { unitSku, caixaComPesoVariavel, canUseFractionedInput } = getSobraQuantityConfig(item)

  if (volumeValue === '' && (unitsValue === '' || !canUseFractionedInput || caixaComPesoVariavel)) {
    return ''
  }

  return convertVolumeAndUnitsToQuantity({
    volume: volumeValue,
    units: canUseFractionedInput ? unitsValue : 0,
    unitSku,
    caixaComPesoVariavel,
  })
}

export function formatSobraQuantity(item, quantity) {
  const { unitSku, caixaComPesoVariavel, unAgregadora, unFracionada } = getSobraQuantityConfig(item)

  return formatQuantityToVolumeAndUnits({
    quantity,
    unitSku,
    caixaComPesoVariavel,
    unAgregadora,
    unFracionada,
  })
}
